import http from '../../utils/http';

// 获取套餐活动列表
export const getActiveActivities = () => {
  return http.post('/api/Recharge/GetActiveActivities');
};

// 创建微信支付订单
export const createWeChatNativePayOrder = (activityId) => {
  return http.post(`/api/Recharge/CreateWeChatNativePayOrder?activityId=${activityId}`);
};

// 获取购买记录
export const getPurchaseRecords = (params = { searchKey: '', yearRange: 0 }) => {
  return http.post('/api/Recharge/GetPurchaseRecords', params);
};

// 查询微信支付订单状态
export const queryWechatOrder = (orderId) => {
  return http.post(`/api/Recharge/QueryWeChatOrder?orderId=${orderId}`);
};

// 处理支付回调
export const processPayment = (orderId, payMethod) => {
  return http.post(`/api/Recharge/ProcessPayment?orderId=${orderId}&payMethod=${payMethod}`);
};
